<template>
  <div>
    <a-page-header class="page-header" @back="back">
      <div slot="title" style="cursor: pointer" @click="back">
        返回 班级管理/
        <span style="color: #297ede">{{ cardObj.title }}</span>
      </div>
    </a-page-header>
    <!--<div style="padding: 0 20px">-->
    <!--  <div style="margin: 15px 0">-->
    <!--    <div style="margin-bottom: 10px; font-size: 17px">{{ cardObj.title }}</div>-->
    <!--    <a-button type="primary" @click="downloadWord">下载主题word文档</a-button>-->
    <!--  </div>-->
    <!--  <div>-->
    <!--    <WordParser :fileUrl="cardObj.fileUrl" />-->
    <!--  </div>-->
    <!--</div>-->
  </div>
</template>

<script>
import WordParser from '@/components/WordParser'

export default {
  name: 'SchemeDetails',
  components: {
    WordParser,
  },
  props: {
    cardObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  created() {
    console.log('卡片详情页面信息：', this.$router.history)
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
  },
}
</script>
<style scoped lang="less">
.page-header {
  padding: 0;
  /deep/ .ant-page-header-heading-title {
    font-size: 14px;
  }
}
</style>
